"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = require("../../command-expander");
exports.tilde = command_expander_1.lookupOrAppend({
    o: "õ",
    a: "ã",
    n: "ñ",
    O: "Õ",
    A: "Ã",
    N: "Ñ"
}, "\u0303");
//# sourceMappingURL=tilde.js.map